module.exports = __webpack_public_path__ + "img/Steam_Icon.c2352015.svg";